import { useMutation } from "@tanstack/react-query";
import ApiService from "@/api/ApiService";
import { updateTransportOrderStatus, useTransportOrderStatus } from "@/stores/transportOrderStatus";
import type { TransportOrderStatus } from "@/stores/transportOrderStatus";
import { useTransportSyncFeedback } from "./TransportSyncFeedback";
import type { TransportSyncAnswer } from "./transportSyncPresentation";

/** All status controls share this behavior; calendar/list queries remain untouched. */
export function useTransState(id: number, initialStatus: TransportOrderStatus) {
  const status = useTransportOrderStatus(id, initialStatus);
  const feedback = useTransportSyncFeedback();
  const mutation = useMutation<TransportSyncAnswer, unknown, TransportOrderStatus>({
    mutationFn: ApiService.setTransportOrderStatus(id),
    onSuccess: (answer, next) => {
      updateTransportOrderStatus(id, next);
      feedback.onSuccess(answer, next);
    },
    onError: feedback.onError,
  });
  return { status, mutation };
}
